export default __webpack_public_path__ + "static/media/play.f070f4f3.svg";